export type tableLimitProps = {
    defaultLimit: number
    currentPageLimit: number
    sortOrder?: 'asc' | 'desc'
    type?: 'default' | 'current'
    increment?: number
}
export type tablePageProps = {
    currentPage: number
}
export type tableStorePrevContextProps = {
    id: string
    path: string
    childPath: string | string[] | null
    activeTab?: number
    forceForget: boolean | null
}
export type tableStoreContextInput = Partial<Omit<tableStorePrevContextProps, 'id'>> & {
    childPath?: string | string[] | null
}
export type tableStoreCurrContextProps = {
    path: string | string[]
}
export enum TableConstraints {
    Default = 'default',
    Current = 'current'
}

